import { FC } from "react";
import { FactureAPayer } from "../../lib/interfaces/factures.interface";
import { formatDate } from "../../lib/helpers/date_helpers";
import { AlertCircle, CalendarDays, FileText } from "lucide-react";
import CommentPayerFactureDialog from "./CommentPayerFactureDialog";

interface Props {
  facture: FactureAPayer;
}

const FactureAPayerItem: FC<Props> = ({ facture: fac }) => {
  return (
    <aside className="overflow-hidden rounded-2xl border border-[#ead893] bg-[#fff9e8] shadow-[0_12px_35px_-30px_rgba(113,83,14,0.8)]">
      <div className="flex gap-4 p-5 sm:p-6">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#f3d974] text-[#725716]">
          <AlertCircle className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="font-bold text-[#4e3d12]">Paiement requis</h2>
          <p className="mt-1 text-sm leading-6 text-[#725f28]">{fac.description}</p>

          <dl className="mt-4 grid gap-3 text-sm sm:grid-cols-3">
            <div className="flex items-center gap-2">
              <FileText className="h-4 w-4 text-[#9a7c28]" />
              <div>
                <dt className="text-xs text-[#8a7540]">Facture</dt>
                <dd className="font-semibold text-[#4e3d12]">n°{fac.numero}</dd>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <CalendarDays className="h-4 w-4 text-[#9a7c28]" />
              <div>
                <dt className="text-xs text-[#8a7540]">Émise le</dt>
                <dd className="font-semibold text-[#4e3d12]">{formatDate(fac.date)}</dd>
              </div>
            </div>
            <div>
              <dt className="text-xs text-[#8a7540]">Montant</dt>
              <dd className="text-lg font-bold tabular-nums text-[#4e3d12]">
                {(fac.montant / 100).toFixed(2)} €
              </dd>
            </div>
          </dl>

          <div className="mt-5">
            <CommentPayerFactureDialog facture={fac} />
          </div>
        </div>
      </div>
    </aside>
  );
};

export default FactureAPayerItem;
